import {defaultDataIdFromObject, TypePolicies} from '@apollo/client/core';
import {StoreObject} from '@apollo/client/utilities';
import {cloneDeep, mergeDeep} from 'app/core/helpers/object';

export const dataIdFromObject = (storeObj: Readonly<StoreObject>, context?: any | undefined): string | undefined => {
    if (storeObj && storeObj.__typename === 'PlainValue') {
        return undefined;
    }
    return defaultDataIdFromObject(storeObj, context);
};

export const typePolicies: TypePolicies = {
    Query: {
        fields: {
            analytics: {
                merge(existing, incoming, opt) {
                    if (
                        incoming &&
                        typeof incoming === 'object' &&
                        Object.keys(incoming).every(key => key === '__typename' || key.startsWith('richStats'))
                    ) {
                        return {...existing, ...incoming};
                    }
                    return mergeDeep(cloneDeep({...existing}), cloneDeep({...incoming}));
                },
            },
        },
    },
    StatsValue: {
        keyFields: false,
        fields: {
            id: {
                merge(existing, incoming, opt) {
                    return (incoming ? incoming : existing) || null;
                },
            },
        },
    },
    WaterfallConfigurationStats: {
        keyFields: false,
        fields: {
            id: {
                merge(existing, incoming, opt) {
                    return (incoming ? incoming : existing) || null;
                },
            },
        },
    },
    RetentionStatsValue: {
        keyFields: false,
        fields: {
            id: {
                merge(existing, incoming, opt) {
                    return (incoming ? incoming : existing) || null;
                },
            },
        },
    },
    FilterOptionValue: {
        fields: {
            parentId: {
                merge(existing, incoming, opt) {
                    return (incoming ? incoming : existing) || null;
                },
            },
        },
    },
    BidManagerQueries: {
        merge: true,
    },
};
